import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import { ROUTES } from '../../constants/routes';
import { UI, EASE } from '../../styles/tl5';
import { useGetPageSectionsQuery } from '../../store/siteContentApi';

// "Get the TrustLab app" — the last band on the page, and the target of
// the footer's three app links via the #apps anchor.
//
// Both store buttons point at ROUTES.APP_DOWNLOAD rather than a store URL
// directly: that route already sniffs the platform and forwards to Play
// or the App Store, and it is the URL every printed QR code encodes.
const STORES = [
  { small: 'GET IT ON', big: 'Google Play' },
  { small: 'DOWNLOAD ON THE', big: 'App Store' },
];

const Apps = () => {
  const { data: sections } = useGetPageSectionsQuery('home');
  const c = sections?.apps || {};
  const heading = c.heading || 'Get the TrustLab app';
  const lede = c.lede || 'Book, track and keep every family report in one place.';

  return (
  <Box
    component="section"
    id="apps"
    sx={{ width: '100%', maxWidth: 1320, mx: 'auto', px: 2, pb: 9 }}
  >
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px 24px',
        p: '16px 22px',
        borderRadius: '24px',
        bgcolor: '#FFFFFF',
      }}
    >
      <Box component="span" sx={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
        <Box component="span" sx={{ fontFamily: UI, fontSize: 17, fontWeight: 800 }}>
          {heading}
        </Box>
        <Box component="span" sx={{ fontFamily: UI, fontSize: 13, color: 'var(--tl-muted-2)' }}>
          {lede}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
        {STORES.map((s) => (
          <Box
            key={s.big}
            component={Link}
            to={ROUTES.APP_DOWNLOAD}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              lineHeight: 1.1,
              p: '8px 12px',
              borderRadius: '10px',
              bgcolor: 'var(--tl-g9)',
              color: '#FFFFFF',
              textDecoration: 'none',
              transition: `background-color .25s ${EASE}`,
              '&:hover': { bgcolor: 'var(--tl-g7)', color: '#FFFFFF' },
            }}
          >
            <Box component="span" sx={{ fontFamily: UI, fontSize: 9, fontWeight: 600, opacity: 0.8 }}>
              {s.small}
            </Box>
            <Box component="span" sx={{ fontFamily: UI, fontSize: 13, fontWeight: 800 }}>
              {s.big}
            </Box>
          </Box>
        ))}

        <Box
          component={Link}
          to={ROUTES.PARTNERS}
          sx={{
            px: '6px',
            fontFamily: UI,
            fontSize: 14,
            fontWeight: 800,
            color: 'var(--tl-teal-d)',
            textDecoration: 'none',
            '&:hover': { color: 'var(--tl-g9)' },
          }}
        >
          Partner &amp; Trustian apps →
        </Box>
      </Box>
    </Box>
  </Box>
  );
};

export default Apps;
